const fieldWidthToGridSizeMap = {
    auto: "auto",
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    "10": 10,
    "11": 11,
    "12": 12
};
export function mapFieldWidthToGridSize(width) {
    return fieldWidthToGridSizeMap[width];
}
export var ErrorDisplay;
(function (ErrorDisplay) {
    ErrorDisplay["Never"] = "Never";
    ErrorDisplay["Touched"] = "Touched";
    ErrorDisplay["Always"] = "Always";
    ErrorDisplay["AlwaysNoMessage"] = "AlwaysNoMessage";
    ErrorDisplay["TouchedNoMessage"] = "TouchedNoMessage";
})(ErrorDisplay || (ErrorDisplay = {}));
export var TemplateDataSource;
(function (TemplateDataSource) {
    TemplateDataSource["CalcRules"] = "CalcRules";
    TemplateDataSource["Resource"] = "Resource";
})(TemplateDataSource || (TemplateDataSource = {}));
export var CustomGuiFieldHandling;
(function (CustomGuiFieldHandling) {
    CustomGuiFieldHandling["Require"] = "Require";
    CustomGuiFieldHandling["Auto"] = "Auto";
    CustomGuiFieldHandling["Ignore"] = "Ignore";
})(CustomGuiFieldHandling || (CustomGuiFieldHandling = {}));
export const isDeprecatedPage = (page) => page.panels == null ||
    Object.keys(page.panels).length === 0;
export const isTemplatePage = (page) => !isDeprecatedPage(page);
//# sourceMappingURL=FormTemplate.js.map